const backendUrl = process.env.REACT_APP_API_URL;
const websocketUrl = process.env.REACT_APP_WS_API_ARL;
const secret = undefined;
const tsApiUrl = undefined;

export { backendUrl, secret, websocketUrl, tsApiUrl };
